module.exports = __webpack_public_path__ + "img/realstate.3515bf6c.png";